<template>
  <div class="animated fadeIn salary-config-history-page">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <h4>Lịch sử cấu hình tính lương</h4>
          <el-button class="salary-config-history__btn" plain @click="goBack">
            Quay lại
          </el-button>
        </div>

        <el-table
          :data="historyItems"
          border
          fit
          class="salary-config-history-table"
          :header-cell-style="getHeaderCellStyle"
        >
          <el-table-column label="STT" width="50" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="Tên phiên bản" min-width="320">
            <template slot-scope="scope">
              {{ getHistoryVersionName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="Ngày tạo" min-width="180">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column label="Thao tác" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                plain
                round
                type="primary"
                class="salary-config-history__icon-btn"
                title="Xem chi tiết"
                @click="openDetail(scope.row)"
              >
                <i class="far fa-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-empty
          v-if="!historyItems.length"
          description="Chưa có lịch sử cấu hình tính lương"
        ></el-empty>
      </div>
    </div>

    <el-dialog
      title="Xem chi tiết lịch sử cấu hình tính lương"
      :visible.sync="showDetailDialog"
      width="94vw"
      custom-class="salary-config-history-detail-dialog"
    >
      <div class="salary-config-history-detail-toolbar">
        <div class="salary-config-history-detail-version">
          {{ selectedHistoryItem ? getHistoryVersionName(selectedHistoryItem) : "" }}
        </div>
        <el-select
          :value="selectedContractTypeId"
          filterable
          class="salary-config-history-contract-select"
          placeholder="Chọn loại hợp đồng"
          @change="handleContractTypeChange"
        >
          <el-option
            v-for="item in contractTypeOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>

      <div class="salary-config-history-detail-table-wrap">
        <el-table
          :data="selectedHistoryConfigs"
          border
          height="520"
          class="salary-config-history-detail-table"
          :header-cell-style="getHeaderCellStyle"
        >
          <el-table-column label="STT" width="50" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="displayName"
            label="Tên cột"
            width="200"
            class-name="salary-config-history-detail-cell--name"
          >
          </el-table-column>
          <el-table-column prop="codeLabel" label="Mã cột" width="200">
            <template slot-scope="scope">
              {{ scope.row.codeLabel || scope.row.code || "" }}
            </template>
          </el-table-column>
          <el-table-column label="Công thức tính" min-width="410">
            <template slot-scope="scope">
              <span class="salary-config-history__formula">{{ getFormulaByContractType(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Diễn giải" min-width="560">
            <template slot-scope="scope">
              <span class="salary-config-history__description">{{ getHistoryDescription(scope.row) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ALL_CONTRACT_TYPE_FORMULA_KEY,
} from "../shared/salaryFormulaConfig";
import ContractTypeApi from "../../../../moduleApi/ContractTypeApi";
import SalaryApi from "../../../../moduleApi/SalaryApi";

export default {
  data() {
    return {
      historyItems: [],
      selectedHistoryItem: null,
      selectedContractTypeId: ALL_CONTRACT_TYPE_FORMULA_KEY,
      contractTypes: [],
      showDetailDialog: false,
    };
  },

  computed: {
    selectedHistoryConfigs() {
      return this.selectedHistoryItem && Array.isArray(this.selectedHistoryItem.configs)
        ? this.selectedHistoryItem.configs
        : [];
    },

    contractTypeOptions() {
      const optionMap = new Map();
      const addOption = (item) => {
        if (!item || item.id === undefined || item.id === null) {
          return;
        }
        const id = `${item.id}`;
        optionMap.set(id, {
          id: item.id,
          name: item.name || item.label || id,
        });
      };

      (this.selectedHistoryItem && Array.isArray(this.selectedHistoryItem.contractTypes)
        ? this.selectedHistoryItem.contractTypes
        : []
      ).forEach(addOption);
      (this.contractTypes || []).forEach(addOption);

      this.selectedHistoryConfigs.forEach((config) => {
        const formulaMap =
          config.contractTypeFormulas && typeof config.contractTypeFormulas === "object"
            ? config.contractTypeFormulas
            : {};
        Object.keys(formulaMap)
          .filter((key) => key !== ALL_CONTRACT_TYPE_FORMULA_KEY)
          .forEach((key, index) => {
            if (!optionMap.has(`${key}`)) {
              optionMap.set(`${key}`, {
                id: key,
                name: `Loại hợp đồng ${index + 1}`,
              });
            }
          });
      });

      return Array.from(optionMap.values());
    },
  },

  async mounted() {
    await this.loadContractTypes();
    await this.loadHistoryItems();
  },

  methods: {
    async loadContractTypes() {
      try {
        const response = await ContractTypeApi.list({ limit: 1000000, filters: "disabled!=true" }, true);
        this.contractTypes = Array.isArray(response && response.result) ? response.result : [];
      } catch (error) {
        this.contractTypes = [];
      }
    },

    async loadHistoryItems() {
      try {
        const response = await SalaryApi.GetFormulaConfigHistory();
        const items = Array.isArray(response)
          ? response
          : Array.isArray(response && response.result)
          ? response.result
          : [];
        this.historyItems = items.map((item) => ({
          ...item,
          createdAt: item.createdAt || item.created_at,
          versionName: item.versionName || item.version_name,
          configs: Array.isArray(item.configs) ? item.configs : [],
          contractTypes: Array.isArray(item.contractTypes)
            ? item.contractTypes
            : Array.isArray(item.contract_types)
            ? item.contract_types
            : [],
        }));
      } catch (error) {
        this.historyItems = [];
        if (window.toastr) {
          window.toastr.error("Không tải được lịch sử cấu hình tính lương.");
        }
      }
    },

    openDetail(item) {
      this.selectedHistoryItem = item;
      const firstContractType = this.contractTypeOptions[0];
      this.selectedContractTypeId = firstContractType
        ? firstContractType.id
        : ALL_CONTRACT_TYPE_FORMULA_KEY;
      this.showDetailDialog = true;
    },

    handleContractTypeChange(contractTypeId) {
      this.selectedContractTypeId = contractTypeId || ALL_CONTRACT_TYPE_FORMULA_KEY;
    },

    getFormulaByContractType(row) {
      if (!row) {
        return "";
      }

      const contractTypeFormulas =
        row.contractTypeFormulas && typeof row.contractTypeFormulas === "object"
          ? row.contractTypeFormulas
          : {};

      if (this.selectedContractTypeId && contractTypeFormulas[this.selectedContractTypeId] !== undefined) {
        return contractTypeFormulas[this.selectedContractTypeId] || "";
      }

      if (contractTypeFormulas[ALL_CONTRACT_TYPE_FORMULA_KEY] !== undefined) {
        return contractTypeFormulas[ALL_CONTRACT_TYPE_FORMULA_KEY] || "";
      }

      return row.formula || "";
    },

    buildFormulaDescription(row) {
      const formula = this.getFormulaByContractType(row);
      if (!formula) {
        return row && row.description ? row.description : "";
      }
      return row && row.displayName ? `${row.displayName} = ${formula}.` : formula;
    },

    getHistoryDescription(row) {
      return row && row.description ? row.description : this.buildFormulaDescription(row);
    },

    getHistoryVersionName(item) {
      if (!item) {
        return "";
      }
      const savedName = `${item.versionName || item.name || ""}`.trim();
      const savedNameDate = new Date(savedName);
      if (savedName && Number.isNaN(savedNameDate.getTime())) {
        return savedName;
      }

      const createdDate = new Date(item.createdAt);
      if (Number.isNaN(createdDate.getTime())) {
        return "Cấu hình tính lương";
      }
      return `Cấu hình tính lương tháng ${createdDate.getMonth() + 1} năm ${createdDate.getFullYear()}`;
    },

    formatDateTime(value) {
      if (!value) {
        return "";
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return "";
      }
      return date.toLocaleString("vi-VN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    goBack() {
      this.$router.push({ name: "Admin-Salary-SalaryConfig-SalaryConfig" }).catch(() => {});
    },

    getHeaderCellStyle() {
      return {
        background: "#f89b56",
        color: "#ffffff",
        fontWeight: "700",
      };
    },
  },
};
</script>

<style scoped>
.salary-config-history-page {
  padding-right: 20px;
}

.salary-config-history-page .main-card-body {
  padding-left: 22px;
  padding-right: 22px;
}

.salary-config-history-page .body-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.salary-config-history-page .body-header h4 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #303133;
}

::v-deep .salary-config-history__btn,
::v-deep .salary-config-history__icon-btn {
  color: #ffffff;
  background: #f89b56;
  border-color: #f89b56;
}

::v-deep .salary-config-history__btn:hover,
::v-deep .salary-config-history__btn:focus,
::v-deep .salary-config-history__icon-btn:hover,
::v-deep .salary-config-history__icon-btn:focus {
  color: #ffffff;
  background: #f58b3d;
  border-color: #f58b3d;
}

::v-deep .salary-config-history-table,
::v-deep .salary-config-history-table::before,
::v-deep .salary-config-history-detail-table,
::v-deep .salary-config-history-detail-table::before {
  border: none !important;
}

::v-deep .salary-config-history-table .el-table__body .cell,
::v-deep .salary-config-history-detail-table .el-table__body .cell {
  color: #606266;
  line-height: 1.55;
  word-break: break-word;
}

::v-deep .salary-config-history-detail-dialog {
  max-width: 1480px;
  min-width: 960px;
  border-radius: 8px;
  overflow: hidden;
}

::v-deep .salary-config-history-detail-dialog .el-dialog__header {
  padding: 10px 12px;
  background: #f89b56;
}

::v-deep .salary-config-history-detail-dialog .el-dialog__title {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
}

::v-deep .salary-config-history-detail-dialog .el-dialog__headerbtn {
  top: 12px;
}

::v-deep .salary-config-history-detail-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #ff5f5f;
  font-weight: 700;
}

::v-deep .salary-config-history-detail-dialog .el-dialog__body {
  padding: 22px 24px 18px;
}

.salary-config-history-detail-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.salary-config-history-detail-version {
  min-width: 0;
  color: #303133;
  font-size: 16px;
  font-weight: 700;
}

.salary-config-history-contract-select {
  flex: 0 0 auto;
  width: 340px;
}

.salary-config-history-detail-table-wrap {
  width: 100%;
  overflow: hidden;
}

::v-deep .salary-config-history-detail-table {
  width: 100% !important;
}

::v-deep .salary-config-history-detail-table .el-table__body .salary-config-history-detail-cell--name .cell {
  color: #4f5661;
  font-weight: 700;
}

.salary-config-history__formula,
.salary-config-history__description {
  display: block;
  white-space: normal;
  color: #606266;
  font-size: 14px;
  line-height: 1.65;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.salary-config-history__formula {
  max-width: 640px;
}

.salary-config-history__description {
  max-width: 680px;
}

::v-deep .salary-config-history-detail-table .el-table__body td {
  vertical-align: top;
}

::v-deep .salary-config-history-detail-table .el-table__body td .cell {
  padding-top: 10px;
  padding-bottom: 10px;
}

@media (max-width: 768px) {
  .salary-config-history-page {
    padding-right: 0;
  }

  .salary-config-history-page .main-card-body {
    padding-left: 16px;
    padding-right: 16px;
  }

  .salary-config-history-page .body-header {
    flex-direction: column;
    align-items: stretch;
  }

  ::v-deep .salary-config-history-detail-dialog {
    min-width: 0;
    width: 96vw !important;
  }

  .salary-config-history-detail-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .salary-config-history-contract-select {
    width: 100%;
  }
}
</style>
